// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import OrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { checkoutReviewAndSubmitStyle } from "@keller/Overrides/Widgets/CheckoutReviewAndSubmit/checkoutReviewAndSubmit.shared.styles";
import { rfqConfirmationDetailsStyles } from "@keller/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { css } from "styled-components";

rfqConfirmationDetailsStyles.detailsGridContainer = {
    gap: 20,
    css: css`
        margin-bottom: 20px;
    `,
};

rfqConfirmationDetailsStyles.leftColumnInnerGridContainer = {
    gap: 20,
};

rfqConfirmationDetailsStyles.leftColumnGridItem = {
    width: 12,
};

rfqConfirmationDetailsStyles.rightColumnGridItem = {
    width: 12,
};

rfqConfirmationDetailsStyles.jobNameGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqConfirmationDetailsStyles.salesRepGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqConfirmationDetailsStyles.dateGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        p {
            font-size: 12px;
            line-height: 18px;
        }
    `,
};

rfqConfirmationDetailsStyles.customerGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqConfirmationDetailsStyles.shipToGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqConfirmationDetailsStyles.jobNameHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};
rfqConfirmationDetailsStyles.salesRepHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};
rfqConfirmationDetailsStyles.statusHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};
rfqConfirmationDetailsStyles.customerHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};
rfqConfirmationDetailsStyles.shipToHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};
rfqConfirmationDetailsStyles.notesHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqConfirmationDetailsStyles.dateLabelText = {
    ...OrderInformationStyles.headingAndTextStyles?.heading,
};

rfqConfirmationDetailsStyles.dividerGridItem = {
    css: css`
        ${checkoutReviewAndSubmitStyle.reviewSection.dividerGridItem?.css}
        &&& {
            margin-bottom: 25px;
            width: 100%;
        }
    `,
};

rfqConfirmationDetailsStyles.gridItem = {
    ...checkoutReviewAndSubmitStyle.reviewSection.gridItem,
};

rfqConfirmationDetailsStyles.blockCard = {
    wrapper: {
        css: css`
            &&& {
                padding-right: 0;
                padding-left: 0;
            }
        `,
    },
    infoWrapper: {
        css: css`
            max-width: 100%;
            padding: 24px;
            @media print {
                padding: 0;
            }
        `,
    },
    title: {
        as: "h3",
        weight: 900,
        css: css`
            margin-bottom: 12px;
            font-size: 24px;
            line-height: 30px;
        `,
    },
    description: {
        weight: "normal",
        css: css`
            margin-bottom: 20px;
        `,
    },
};
